//import moment from 'moment';

import { AjoutDeduire } from '../data/Interfaces';
import { minutesDifferenceToDecimalHours } from './getCalendarMonthMatrix';
export function getDisabledValidateRejectCraForACanceledMission(statutMission, BDCs, bdcIdLinkedToCurrentCra) {
    /**
     *annuler peut se faire just sur un bdc qui a max un seul cra, un BDC avec deux cra ne peut pas etre annulle, normalemnt sont les bdc issue immidiatement de la creationMission/renouvellement
     * on peut pas actionner (valider/rejeter) un cra d une mission annule, et on etait sur le cra du dernier BDC.
     */
    if(statutMission =='annulee'){
        if(Array.isArray(BDCs)){
            // * le dernier BDC howa li vraiment/reelement annulee, donc le cra dyalo (max un, car on peut pas annuler une mission/bdc qui a max 1cra)
            //! I removed populate({'BDCs'}), no need to get the _id: OLD: return BDCs[BDCs.length - 1]?._id == bdcIdLinkedToCurrentCra;
            return BDCs[BDCs.length - 1] == bdcIdLinkedToCurrentCra;
            // * we need to populate on them from the backend
            // return BDCs[BDCs.length -1].CRAs.includes(craIdOrCraXId) ||
            // BDCs[BDCs.length -1].CRAXs.includes(craIdOrCraXId);
        }
        else return false;
        // * tjrs vrai car ce sont les BDC li kiyning west lcra, dont normal lcra rah westom
        // BDC.CRAs.includes(craIdOrCraXId) ||
        // BDC.CRAXs.includes(craIdOrCraXId);
    }
    else return false;
}

export const initializeAstreinte = (index) => {
    return {
        type: '',
        montantUnit: 0,
        nbrAstreintes:'',
        date: '',
        index: index,
    };
};

export const initializeAstreinteRegularisation = (index) => {
    return {
        type: '',
        ajout: AjoutDeduire[0].value, //*was ' '
        nbrAstreintes: 0,
        montantUnit: 0,
        index: index,
    };
};

export const initializeHNORegularisation = (index) => {
    return {
        type: '',
        coefficient: 1,

        ajout: AjoutDeduire[0].value, //* was ' '
        nbrHeure: '',

        // nbrHNO: 0,
        // montantClient:0,
        // montantExpert:0,
        index: index,
    };
};

export const initializeHNO = (index) => {
    return {
        type: '',
        coefficient: 1,
        date: null,
        heureDebut: '',
        heureFin: '',
        total: 0,
        index: index,
    };
};

export const initializeNotesFraisReg = (index) => {
    return {
        type: '',
        montant: 0,
        ajout: AjoutDeduire[0].value, //*was ' '
        index: index,
    };
};

export const initializeNotesFrais = (index) => {
    return {
        type: '',
        montant: 0,
        index: index,
    };
};

export const calculateMontantTotalOfOneAstreinte = (astreinte,isMontant,role,tj,tjClient) => {
    return (calculateIsMontantOrCoeffOfAstreinte(astreinte?.montantUnit,isMontant,role,tj,tjClient)) * Number(astreinte?.nbrAstreintes);
};

export const calculateIsMontantOrCoeffOfAstreinte = (montant,isMontant,role,tj,tjClient) => {
    if((role=='client' || role=='admin')){
        if(isMontant)
            return Number(montant);
        else{
            return (Number(tjClient) * (Number(montant)/100)).toFixed(2);
        }
    }
    else{
        if(isMontant)
            return Number(montant);
        else
            return (Number(tj) * (Number(montant)/100)).toFixed(2);
    }

};

export const calculateMontantTotalOfOneAstreinteReg = ({astreinte,isMontant,role,tj,tjClient}) => {
    console.log('tj',tj,'tjClient',tjClient,'client',Number(tjClient)*(Number(astreinte?.montantUnit)/100),'expert',Number(tj)*(Number(astreinte?.montantUnit)/100));
    if(astreinte?.ajout=='deduire')
        if((role=='client' || role=='admin')){
            if(isMontant)
                return Number(astreinte?.montantUnit) * Number(astreinte?.nbrAstreintes)*(-1);
            else
                return Number(tjClient)*(Number(astreinte?.montantUnit)/100) * Number(astreinte?.nbrAstreintes)*(-1);
        }
        else{
            if(isMontant)
                return Number(astreinte?.montantUnit) * Number(astreinte?.nbrAstreintes)*(-1);
            else
                return Number(tj)*(Number(astreinte?.montantUnit)/100) * Number(astreinte?.nbrAstreintes)*(-1);
        }
    else{
        if((role=='client' || role=='admin')){
            if(isMontant)
                return Number(astreinte?.montantUnit) * Number(astreinte?.nbrAstreintes);
            else
                return Number(tjClient)*(Number(astreinte?.montantUnit)/100) * Number(astreinte?.nbrAstreintes);
        }
        else{
            if(isMontant)
                return Number(astreinte?.montantUnit) * Number(astreinte?.nbrAstreintes);
            else
                return Number(tj)*(Number(astreinte?.montantUnit)/100) * Number(astreinte?.nbrAstreintes);
        }
    }
};

export const calculateMontantTotalAstreintesReg = ({astreintesFileList,isMontant,role,tj,tjClient}) => {
    return astreintesFileList?.reduce((acc, curr) => acc + (calculateMontantTotalOfOneAstreinteReg({astreinte:curr,isMontant,role,tj,tjClient})), 0);
};

export const calculateMontantTotalAstreintes = (astreintesFileList,isMontant,role,tj,tjClient) => {
    return astreintesFileList?.reduce((acc, curr) => acc + (calculateIsMontantOrCoeffOfAstreinte(curr?.montantUnit,isMontant,role,tj,tjClient)* Number(curr?.nbrAstreintes)), 0);
};
export const calculateMontantTotalNoteFrais = (notesFraisFileList) => {
    return notesFraisFileList?.reduce((acc, curr) => acc + (Number(curr?.montant)), 0);
};

export const calculateMontantTotalOfOneHno = ({hno, tj,  role, tjClient, nbrHrHno}) => {
    if(role=='client' || role=='admin'){
        // * make sure that 'totalHno'(4Client):  cra?.totalHnos? Number(cra?.totalHnos)*Number(cra?.totalHnos + (cra?.commissionHTH/100)) will equals to:
        // ! coeff * nbrHeurs * tj/8
        // * OLD return Number(hno?.coefficient) * Number(minutesDifferenceToDecimalHours(hno?.heureDebut, hno?.heureFin)) * (getTjClient(tj, commissionHTH) / 8);
        return (Number(hno?.coefficient) * (Number(minutesDifferenceToDecimalHours(hno?.heureDebut, hno?.heureFin))) * (Number(tjClient)/ Number(nbrHrHno)));
    }
    console.log('calcul',Number(hno?.coefficient) * (Number(minutesDifferenceToDecimalHours(hno?.heureDebut, hno?.heureFin))) * (Number(tj) / Number(nbrHrHno)));
    return (Number(hno?.coefficient) * (Number(minutesDifferenceToDecimalHours(hno?.heureDebut, hno?.heureFin))) * (Number(tj) / Number(nbrHrHno)));
};

export const calculateMontantTotalOfOneHnoReg = ({hno, tj, role, tjClient,nbrHrHno}) => {
    if(role=='client'){
        if(hno?.ajout=='deduire')
            return Number(hno?.coefficient) * Number(hno?.nbrHeure) * (Number(tjClient)/ Number(nbrHrHno))*(-1);
        else
            return Number(hno?.coefficient) * Number(hno?.nbrHeure) * (Number(tjClient)/ Number(nbrHrHno));
    }
    else{
        if(hno?.ajout=='deduire')
            return Number(hno?.coefficient) * Number(hno?.nbrHeure) * (Number(tj) / Number(nbrHrHno))*(-1);
        else
            return Number(hno?.coefficient) * Number(hno?.nbrHeure) * (Number(tj) / Number(nbrHrHno));

    }
};

export const calculateMontantTotalHnos = ({hnosFileList, tj, role, tjClient,nbrHrHno}) => {
    console.log('hnosFileList',hnosFileList,'tj',tj,'tjClient',tjClient,'role',role,'nbrHrHno',nbrHrHno);
    return hnosFileList?.reduce((acc, curr) => acc + (
        calculateMontantTotalOfOneHno({
            hno:curr,
            tj:tj,
            tjClient:tjClient,
            role: role,
            nbrHrHno:nbrHrHno,
        })), 0);
};

export const calculateMontantTotalHnosReg = ({hnosFileList, tj, role, tjClient,nbrHrHno}) => {
    return hnosFileList?.reduce((acc, curr) => acc + (
        calculateMontantTotalOfOneHnoReg({
            hno:curr,
            tj:tj,
            tjClient:tjClient,
            role: role,
            nbrHrHno:nbrHrHno,
        })), 0);
};

export const calculateMontantTotal = ({ astreintesFileList, hnosFileList, notesFraisFileList, tj, role, tjClient,isMontant,nbrHrHno }) => {
    return calculateMontantTotalAstreintes(astreintesFileList,isMontant,role,tj,tjClient)
    + calculateMontantTotalHnos({hnosFileList:hnosFileList, tj: tj, role: role, tjClient: tjClient, nbrHrHno: nbrHrHno})
    + calculateMontantTotalNoteFrais(notesFraisFileList);

};

export const calculateMontantTotalReg = ({ astreintesFileList, hnosFileList, notesFraisFileList, tj, role, tjClient,isMontant,nbrHrHno }) => {
    return calculateMontantTotalAstreintesReg({astreintesFileList,isMontant,role,tj,tjClient})
    + (calculateMontantTotalHnosReg({hnosFileList:hnosFileList, tj: tj, role: role, tjClient: tjClient,nbrHrHno:nbrHrHno}))
    + (calculateMontantTotalNoteFrais(notesFraisFileList));
};

export const filesAddapter = (fileListFromBackend) => {
    if(Array.isArray(fileListFromBackend)) {
        return fileListFromBackend.map((file)=> {
            return {
                name: file?.url.substring(file?.url.lastIndexOf('\\')+1),
                dateTelechargement: file?.dateTelechargement,
                isFromBackend: true,
                ...file
            };
        });
    }
};

export const getCommissionHTH= ({tj, tjClient}) => {
    return ((1 - (tj / tjClient)) * 100).toFixed(2);
};

// * return always the mission property of these three properties (inputs)
export const getPaymentSimulationResults= ({tj, tjClient, commissionHTH}) => {
    if(tj && tjClient)
        return {commissionHTH: Number(((1 - (tj / tjClient)) * 100).toFixed(2))};
    else if(tj && commissionHTH){
        if (commissionHTH >= 0 && commissionHTH < 1) {
            return {tjClient: Number(Math.round(Number(tj) / Number(1 - commissionHTH)))};
        } else if (commissionHTH >= 1 && commissionHTH <= 100) {
            return {tjClient: Number(Math.round(Number(tj) / Number(1 - (commissionHTH/100))))};
        }
    }
    else if(tjClient && commissionHTH){
        if (commissionHTH >= 0 && commissionHTH < 1) {
            return {tj: Number(Math.round(Number(tjClient) * Number(1 - commissionHTH)))};
        } else if (commissionHTH >= 1 && commissionHTH <= 100) {
            return {tj: Number(Math.round(Number(tjClient) * Number(1 - (commissionHTH/100))))};
        }
    }
};

export const getMontatantTTC = (montantHT, tva=0) => {
    if(montantHT)
        // return montantHT + montantHT * (tva/100); //* v2 with the attach function / even addEuro .. when we concatenate a result from a calcul ,, it gives a NaN ..
        return Number(montantHT + montantHT * (tva/100)).toFixed(2);
    else return 0;
};

export const getMargeBrute = (PrixVente, PrixAchat) => {
    if(PrixVente && PrixAchat)
        // return PrixVente - PrixAchat;
        return Number(PrixVente - PrixAchat).toFixed(2);
    else return '';
};

export const getMargeNet = (MargeBrut, CA) => {
    if(MargeBrut && CA)
        // return 0.9 * CA - MargeBrut;
        //return Number( 0.9 * CA - MargeBrut).toFixed(2);
        return Number(MargeBrut - 0.1*CA).toFixed(2);

    else return '';
};